import React, { useState } from "react";
import Button from "../components/Button";
// import useNavigation from "../hooks/use-navigation";
import { login, setToken, getCurrentUser } from "../services/Apis";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  function validateForm() {
    return email.length > 0 && password.length > 0;
  }

  async function handleSubmit(event) {
    setError(null);
    event.preventDefault();
    const res = await login(email, password);
    if (res === "Unable to login" || res === "Invalid email/password")
      return setError("Incorrect Credentials");
    if (res.token != null) setToken(res.token);

    if (getCurrentUser() != null) {
      navigate("/");
    } else console.log("error");
  }

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleChangePass = (event) => {
    setPassword(event.target.value);
  };

  const handleReset = (event) => {
    event.preventDefault();
    navigate("/change-pass");
  };
  return (
    <div className="flex justify-center">
      <h1 className="mt-5 text-4xl">Login Page</h1>
      <div className="fixed flex justify-center top-1/3 ml-1/4 mr-1/4 min-w-fit border-solid border-2 px-24 py-2 bg-slate-200">
        <div className="flex flex-col items-center">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col items-center text-center">
              <label className="text-blue-500 text-lg">Email</label>
              <input
                autoFocus
                className="border-solid border-2 pl-7 pr-7 mr-auto ml-auto text-center"
                value={email}
                onChange={handleChangeEmail}
              />
            </div>

            <div className="flex flex-col items-center text-center">
              <label className="text-blue-500 text-lg">Password</label>
              <input
                className="border-solid border-2 pl-7 pr-7 mr-auto ml-auto text-center"
                value={password}
                onChange={handleChangePass}
              />
            </div>
            {error != null ? (
              <h2 className="text-red-500 mt-1 mb-1 text-center">{error}</h2>
            ) : (
              <span></span>
            )}
            <div className="flex justify-end">
              <Button
                primary
                outline={!validateForm()}
                rounded
                disabled={!validateForm()}
                type="submit"
                className={
                  validateForm() ? "mt-5 active:translate-y-1" : "mt-5"
                }
              >
                Login
              </Button>
            </div>
          </form>
          <div className="mt-4 ml-24">
            <Button
              className="flex active:translate-y-1"
              secondary
              rounded
              onClick={handleReset}
            >
              Change Password{" "}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
